import { toast } from 'react-toastify';
import { userConst } from '../consts';

export function showErrorsIfNeed(error, silentErrors) {
    if (!error) return;
    if (!error.reason || error.reason === 'net') toast.error(`Ошибка сети: ${error.message}`);
    else if (!silentErrors || !silentErrors.includes(error.status)) toast.error(`Ошибка сервера: ${error.message}`);
}

export function processFailure(opts = {}) {
    const { dispatch, error, action } = opts;
    if (error.status === 401) dispatch({ type: userConst.LOGOUT });
    dispatch(action);
}
